function isUserEventInstructor(eventForm, user, resources) {
  const instructorResource = resources[eventForm.instructorID];

  return instructorResource ? instructorResource.userID === user.id : false;
}

function isUserInstructor(user, resources) {
  return Object.keys(resources)
    .find(resourceId => resources[resourceId].userID === user.id && resources[resourceId].resourceTypeName === "Instructor");
}


export { isUserEventInstructor, isUserInstructor }